import * as stateManagement from '@/stateManagement';

export const {
  attachCandidateSel,
  selectedCompsSel,
  singleSelectedCompSel,
  isMultiselectSel,
} = stateManagement.stateMapperArgsSelectors.selectedCompsSels;
